import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import AdminDashboard from './pages/AdminDashboard';
import EditorDashboard from './pages/EditorDashboard';
import ImagingDashboard from './pages/ImagingDashboard';
import TechnicalDashboard from './pages/TechnicalDashboard';
import Login from './pages/Login';
import ReceptionDashboard from './pages/ReceptionDashboard';
import SharedStudy from './pages/SharedStudy';
import { tokenFromPath } from './utils/share';
import './App.css';

const DASHBOARDS = {
  reception: ReceptionDashboard,
  imaging: ImagingDashboard,
  editor: EditorDashboard,
  technical: TechnicalDashboard,
  admin: AdminDashboard,
};

function Routes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="boot">
        <span className="boot__mark" aria-hidden="true" />
        <p>در حال بارگذاری سامانه…</p>
      </div>
    );
  }

  if (!user) return <Login />;

  const Dashboard = DASHBOARDS[user.role];
  if (!Dashboard) {
    return (
      <div className="boot">
        <p>برای حساب شما نقشی تعریف نشده است.</p>
        <p className="muted">با مدیر سامانه تماس بگیرید تا نقش شما مشخص شود.</p>
      </div>
    );
  }

  return <Dashboard />;
}

export default function App() {
  /*
   * برنامه روتر ندارد و نمی‌خواهد داشته باشد — داشبورد بر اساس نقش
   * سوییچ می‌شود. ولی صفحه‌ی عمومیِ لینک مشاهده نشانی واقعی می‌خواهد تا
   * بشود آن را در پیامک فرستاد و در QR گذاشت.
   *
   * پس یک شاخه، همین‌جا و پیش از همه چیز: نه AuthProvider (حسابی در کار
   * نیست و توکنِ جامانده‌ی کارمند نباید قاطی شود)، نه SocketProvider
   * (WebSocketِ سامانه برای پزشک باز نمی‌شود). یک قاعده، نه یک کتابخانه.
   */
  const shareToken = tokenFromPath();
  if (shareToken) {
    return (
      <>
        <ToastContainer position="bottom-left" newestOnTop closeOnClick theme="light" />
        <SharedStudy token={shareToken} />
      </>
    );
  }

  return (
    <AuthProvider>
      <SocketProvider>
        <ToastContainer position="bottom-left" rtl newestOnTop closeOnClick theme="light" />
        <Routes />
      </SocketProvider>
    </AuthProvider>
  );
}
